const prefix = 'bypassedPlans';

export const FETCH_ALL = `${prefix}/FETCH_ALL`;
export const FIND = `${prefix}/FIND`;
export const FIND_UPCOMING = `${prefix}/FIND_UPCOMING`;
export const FIND_UPCOMING_FAILED = `${prefix}/FIND_UPCOMING_FAILED`;
